import React, { useState, useEffect, useRef } from "react";
import { calculateKachelStatus } from "./pureFunctions";
import { statusfarben, statusfarbentext } from "./globalVariables";

export default function ProjektstatusAbwicklungsVorbereitung({ adminView, objekte, userObjects }) {
   useEffect(() => {
      console.log(objekte);
   }, []);
   return (
      <>
         <div className="projektstatus-l2" style={{ flexGrow: 5 }}>
            <h2>
               <small>Vorbereitung Abwicklung</small> | {objekte.length}
            </h2>
            {objekte &&
               objekte.map((objekt, index) => (
                  <a
                     href={"/datenblatt?estateid=" + objekt.id}
                     target="_blank"
                     rel="noopener noreferrer"
                     className={"projektstatus-notartermin"}
                     key={"ohnetermin_" + objekt.id}
                  >
                     {objekt.objektbezeichnung
                        ? objekt.objektbezeichnung
                        : objekt.objektnr_extern +
                          " " +
                          (userObjects[objekt.benutzer] && userObjects[objekt.benutzer].Name)}

                     {(objekt.abwicklungsdatum || objekt.abwicklungsVorbereitungsdatum) && (
                        <small>
                           <br />
                           In Abwicklung seit über{" "}
                           {objekt.abwicklungsVorbereitungsdatum && (
                              <span>
                                 (online){" "}
                                 <strong>
                                    {Math.floor((new Date() - objekt.abwicklungsVorbereitungsdatum) / 86400000)}
                                 </strong>{" "}
                              </span>
                           )}
                           {objekt.abwicklungsdatum && (
                              <span>
                                 (offline){" "}
                                 <strong>{Math.floor((new Date() - objekt.abwicklungsdatum) / 86400000)}</strong>
                              </span>
                           )}{" "}
                           Tagen{" "}
                        </small>
                     )}
                     <div className="flex-row">
                        <div
                           style={{
                              padding: "0 10px",
                              margin: "0 10px",
                              borderRadius: "20px",
                              fontWeight: 700,
                              color: statusfarbentext[calculateKachelStatus(objekt, "projektstatus")],
                              backgroundColor: statusfarben[calculateKachelStatus(objekt, "projektstatus")],
                           }}
                        >
                           PS
                        </div>
                        <div
                           style={{
                              padding: "0 10px",
                              margin: "0 10px",
                              borderRadius: "20px",
                              fontWeight: 700,
                              color: statusfarbentext[calculateKachelStatus(objekt, "ankaufserklarung")],
                              backgroundColor: statusfarben[calculateKachelStatus(objekt, "ankaufserklarung")],
                           }}
                        >
                           AK
                        </div>
                        <div
                           style={{
                              padding: "0 10px",
                              margin: "0 10px",
                              borderRadius: "20px",
                              fontWeight: 700,
                              color: statusfarbentext[calculateKachelStatus(objekt, "notarvorbereitungVerkaufer")],
                              backgroundColor:
                                 statusfarben[calculateKachelStatus(objekt, "notarvorbereitungVerkaufer")],
                           }}
                        >
                           VK
                        </div>
                     </div>
                  </a>
               ))}
         </div>
      </>
   );
}
